import { useEffect } from 'react'
import type { RefObject } from 'react'

/**
 * Moves focus into `ref` when `open` turns true. An editor the user has just opened takes focus as
 * part of that action, the way a dialog does; spelled as focus management rather than `autoFocus`
 * so the page-load case that prop is linted against stays distinct from this deliberate one.
 */
export const useFocusOnOpen = (ref: RefObject<HTMLElement | null>, open = true) => {
  useEffect(() => {
    if (open) ref.current?.focus()
  }, [open, ref])
}
